import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  isVisible = false;
  title = '';
  message = '';
  type = '';
  showButtons = true;
  urlRedirect = '';
constructor() { }



toggleModal(title:string, message:string,isVible:boolean,type:string,urlRedirect?:string){
  this.isVisible= isVible
  this.title = title;
  this.message = message;
  if(type === 'error'){
    this.showButtons=  false;
  }
  if(type === 'info'){
    this.showButtons=  true;
  }
  urlRedirect ? this.urlRedirect = urlRedirect : this.urlRedirect = '';
}

}
